// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N7Kt","toggle":"styles_toggle__1b9nY","preview":"styles_preview__3I630"};